export default {
    name: 'MenuSep',
    template: '<div class="menu-sep"></div>'
}